<template>
  <div class="smaller-container-wrapper full-height no-progress-bar">
    <div class="error-container" data-cy="error">
      <div class="text-center">
        <inline-svg :src="require(`@/assets/error-${errorPayload.errorType}.svg`)" width="64" height="48" alt="" />
      </div>
      <div class="text-center">
        <h2 data-test="heading" class="my-4">{{ $t(`message.common.errors.${errorPayload.errorType}.title`) }}</h2>
        <p v-if="errorPayload.errorMsg" class="error-message px-3 px-sm-4">
          {{ $t(`message.common.errors.${errorPayload.errorType}.msg.${errorPayload.errorMsg}`) }}
        </p>
      </div>
    </div>
    <div class="btn-container text-center">
      <MobialisButton
        v-if="!hideButton"
        class="mt-4 col-11 w-auto-desktop"
        @click="clickButton"
        data-cy="continue"
        v-av-analytics-cta-interaction="{
          elementText: $t(`message.common.errors.${buttonText}`),
          eventActionResult: isReturnToVehicleButton ? 'exit' : 'open',
        }"
        >{{ $t(`message.common.errors.${buttonText}`) }}
      </MobialisButton>
    </div>
  </div>
</template>

<script>
import { modalMethods } from '@/mixins';

export default {
  name: 'Error',
  mixins: [modalMethods],
  data() {
    return {
      errorPayload: {
        errorType: 'general',
        errorMsg: null,
        buttonText: 'returnVehicle',
      },
    };
  },
  computed: {
    isReturnToVehicleButton() {
      return this.errorPayload.buttonText === 'returnVehicle';
    },
    isHomeButton() {
      return this.errorPayload.buttonText === 'returnHome';
    },
    hideButton() {
      return (this.isReturnToVehicleButton && this.hideAllCloseBtns) || (this.isHomeButton && this.hideAllHomeBtns);
    },
    buttonText() {
      if (this.isReturnToVehicleButton) {
        return this.$route.query.vin ? 'returnVehicle' : 'exit';
      }
      return this.errorPayload.buttonText;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isReturnToVehicleButton) {
      next(false);
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.meta.errorPayload) {
        // eslint-disable-next-line no-param-reassign
        vm.errorPayload = {
          ...vm.errorPayload,
          ...to.meta.errorPayload,
        };
      }
    });
  },
  methods: {
    async clickButton() {
      if (this.isReturnToVehicleButton) {
        // Close the modal
        await this.closeModal().catch(error =>
          this.$log('Error updating lead after receiving close message from SDK.', error)
        );
      } else if (this.isHomeButton) {
        this.$router.push({ path: this.homeRoute });
      } else {
        this.$router.push({ path: this.getNextRoutePath() });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.error-container {
  padding-top: 90px;
}
.error-message {
  line-height: 24px;
  max-width: 550px;
  margin: 16px auto;
}
.btn-container {
  margin: 0 -15px;
}
</style>
